import { all, fork } from 'redux-saga/effects';

import watchCartAddRequest from './cartAddRequest';
import watchCartCouponRequest from './cartCouponRequest';
import watchCartRemoveCouponRequest from './cartRemoveCouponRequest';
import watchCartRequest from './cartRequest';
import watchChangeQuantity from './changeQuantity';

function* cartSagas() {
  yield all([
    fork(watchCartRequest),
    fork(watchChangeQuantity),
    fork(watchCartAddRequest),
    fork(watchCartCouponRequest),
    fork(watchCartRemoveCouponRequest),
  ]);
}

export default cartSagas;
